import React, { useEffect, useState } from "react";
import { useStateValue } from "../../StateProvider";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import {
  changePassword,
  editeUser,
  getLoginPageDetail,
  setNewPassword,
} from "../../apiCall";
import toast from "react-hot-toast";
import { useQuery } from "@tanstack/react-query";
import { validateNoBlankSpaces } from "../../utils/formValidation";

const ChangePassword = () => {
  const [, dispatch] = useStateValue();
  const location = useLocation();
  const [isPasswordMatchError, setIsPasswordMatchError] = useState(false);
  const navigate = useNavigate();

  // ***************************************************** fetch company info start *****************************************************
  const fetchData = async () => {
    // Perform the API call to fetch company info
    try {
      const response = await getLoginPageDetail();
      if (response?.status === 200) {
        setLoginPageDetail(response.data);
      } else if (response?.response) {
        toast.error(response?.response?.data?.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  };

  const { data } = useQuery({
    queryKey: ["staff-list"],
    queryFn: () => fetchData(),
  });

  const [loginPageDetail, setLoginPageDetail] = useState(
    data?.status === 200 ? data?.data : {}
  );
  // ***************************************************** fetch company info end *****************************************************

  // ***************************************************** form start *****************************************************
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();
  const onSubmit = async (data) => {
    if (data.newPassword === data.ResetPasswd) {
      dispatch({ type: "SET_LOADING", status: true });
      let re;
      console.log(data);
      if (data?.reset_password_token) {
        re = await setNewPassword(data);
        if (re?.status === 200) {
          navigate("/");
          dispatch({ type: "SET_LOGIN_STATUS", status: true });
          toast.success(re?.data?.message);
        } else if (re?.response) {
          if (re?.response?.data?.message) {
            toast.error(re?.response?.data?.message);
          } else {
            toast.error(re?.response?.data?.status);
          }
        }
      } else {
        re = await changePassword(data?.LoginId, { Pswd: data?.newPassword });

        if (re?.status === 200) {
          navigate("/");
          toast.success(re?.data?.message);
        } else if (re?.response) {
          if (re?.response?.data?.message) {
            toast.error(re?.response?.data?.message);
          } else {
            toast.error(re?.response?.data?.status);
          }
        }
      }
      setIsPasswordMatchError(false);

      dispatch({ type: "SET_LOADING", status: false });
    } else {
      setIsPasswordMatchError(true);
    }
  };

  // ***************************************************** form end *****************************************************

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("resetToken");
    const LoginId = queryParams.get("LoginId");
    setValue("LoginId", LoginId);
    setValue("reset_password_token", token);
  }, []);

  return (
    <div className="container d-flex flex-column">
      <div
        className="row align-items-center justify-content-center g-0
        min-vh-100"
      >
        <div className="col-12 col-md-8 col-lg-6 col-xxl-4 py-8 py-xl-0">
          {/* Card */}
          <div className="card smooth-shadow-md">
            {/* Card body */}
            <div className="card-body p-6 justify-content-center">
              <div className=" d-flex justify-content-center">
                <h1>Task Trak</h1>
              </div>

              <div className=" d-flex justify-content-center">
                <div className="">
                  {loginPageDetail?.company_info?.data?.logo ? (
                    <img
                      src={loginPageDetail?.company_info?.data?.logo}
                      className="mb-2 text-inverse"
                      style={{ height: "50px" }}
                      alt="Image"
                    />
                  ) : (
                    <img
                      src="../assets/images/brand/logo/logo-2.svg"
                      className="mb-2 text-inverse"
                      style={{ height: "50px" }}
                      alt="Image"
                    />
                  )}
                </div>
              </div>
              <div className="mb-4 d-flex justify-content-center">
                <h3 className="text-muted">Change Password</h3>
              </div>
              {/* Form */}
              <form onSubmit={handleSubmit(onSubmit)}>
                {/*Login Id */}
                <div className="mb-3">
                  <label htmlFor="password" className="form-label">
                    Login Id
                  </label>
                  <input
                    type="text"
                    id="password"
                    className="form-control"
                    name="password"
                    placeholder="Login Id"
                    disabled
                    {...register("LoginId", {
                      required: "Login id is required",
                      validate: validateNoBlankSpaces,
                    })}
                  />
                  {errors.LoginId && (
                    <div className="error">{errors.LoginId.message}</div>
                  )}
                </div>
                {/*New Password */}
                <div className="mb-3">
                  <label htmlFor="password" className="form-label">
                    New Password
                  </label>
                  <input
                    type="password"
                    id="password"
                    className="form-control"
                    name="password"
                    placeholder="New Password"
                    onKeyDown={(e) => {
                      if (e.key === " ") {
                        e.preventDefault();
                      }
                    }}
                    {...register("newPassword", {
                      required: "new password is required",
                      validate: validateNoBlankSpaces,
                    })}
                  />
                  {errors.newPassword && (
                    <div className="error">{errors.newPassword.message}</div>
                  )}
                </div>
                {/*Confirm Password */}
                <div className="mb-3">
                  <label htmlFor="password" className="form-label">
                    Confirm Password
                  </label>
                  <input
                    type="password"
                    id="password"
                    className="form-control"
                    name="password"
                    placeholder="Confirm Password"
                    onKeyDown={(e) => {
                      if (e.key === " ") {
                        e.preventDefault();
                      }
                    }}
                    {...register("ResetPasswd", {
                      required: "Confirm password is required",
                      validate: validateNoBlankSpaces,
                    })}
                  />
                  {errors.ResetPasswd && (
                    <div className="error">{errors.ResetPasswd.message}</div>
                  )}
                </div>

                {isPasswordMatchError && (
                  <div className="error">
                    The new password and confirm password do not match.
                  </div>
                )}
                <div>
                  {/* Buttons */}
                  <div className="d-flex justify-content-between">
                    <div
                      type="submit"
                      className=" w-25 btn btn-outline-danger"
                      onClick={() => navigate(-1)}
                    >
                      Cancel
                    </div>
                    <button type="submit" className="w-25 btn btn-primary">
                      Save
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
